import React from 'react';
import {currentResource, labels} from '../../../util/utils';
import ContentSwitcher from '../../Common/BaseComponentWrappers/MotifContentSwitcher';
import Button from '../../Common/BaseComponentWrappers/MotifButton';

export function EditITApplicationContainer(props) {
	const {item, strategyTypeChange, strategyTypeId, isShared} = props;

	const strategyTypes = currentResource.strategyTypes;
	const type = currentResource.itAppTypes;

	const handleToggleOnChage = (e) => {
		strategyTypeChange(e);
	};

	return (
		<section className="editITAppStrategy" id={item.entityId}>
			<section className="itAppStrategyText">{labels.strategy}</section>
			{strategyTypes && (
				<ContentSwitcher
					children={strategyTypes.map((data, index) => {
						return (
							<Button
								value={strategyTypes[index].id}
								onClick={handleToggleOnChage}
								id={data.id}
								variant="secondary"
								className={strategyTypes[index].id === Number(strategyTypeId) ? 'motif-active' : ''}
								disabled={isShared}
								showLabel
								buttonLabel={data.name}
							/>
						);
					})}
				/>
			)}
			<section className="itApplicationText">
				<span className="itApplicationTypeText">{labels.type}:</span>
				<span className="itApplicationTypeVal">
					{item?.isServiceOrganization === false || item?.additionalData?.isServiceOrganization === false
						? type[0].label
						: type[1].label}
				</span>
			</section>
		</section>
	);
}

export default EditITApplicationContainer;
